import React from "react"
import { Classes, Icon } from "@blueprintjs/core"
import classNames from "utils/classNames"
import { getIntentClassName } from "utils/css.utils"

const IconWrapper = (path, viewboxDefault = 20, intent) => {
  return (
    <span className={classNames(Classes.ICON, getIntentClassName(intent))}>
      <Icon
        icon={
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={viewboxDefault}
            height={viewboxDefault}
            viewBox={`0 0 ${viewboxDefault} ${viewboxDefault}`}
          >
            {path}
          </svg>
        }
      />
    </span>
  )
}

const ChemicalTest20 = props =>
  IconWrapper(
    <path d="M15.2274 0H4.77316V1.1364H5.5448V6.2184L0 17.5656L2.3106 20L17.6899 19.998L20 17.5624L14.4557 6.2184V1.1364H15.2268L15.2274 0ZM15.7265 12.152H4.27459L7.08106 6.4088V1.1364H12.92V2.1392H10.5229V3.142H12.92V4.1448H10.5229V5.1472H12.92V6.4092L15.7265 12.152Z" />,
    20,
    props.intent
  )

export const DemandIcon = (
  <svg
    width="33"
    height="26"
    viewBox="0 0 33 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.1312 17.9953C24.7652 17.6774 24.2002 17.7112 23.8777 18.0703L20.5672 21.7571H4.73381C3.61335 21.7571 2.70503 22.6338 2.70503 23.7152V25.347H0V23.7152C0 21.1919 2.1194 19.1463 4.73381 19.1463H19.332L21.8336 16.3604C23.1474 14.8972 25.4496 14.7593 26.9407 16.0546C28.4257 17.3445 28.5829 19.5387 27.296 21.0136L22.9458 25.9997H14.8777V23.3889H21.6873L25.2269 19.3319C25.5738 18.9344 25.5314 18.3429 25.1312 17.9953Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8095 2.47619V8.97619H30.0238V2.47619H19.8095ZM17.3333 1.85714C17.3333 0.83147 18.1648 0 19.1905 0H30.6428C31.6685 0 32.5 0.831471 32.5 1.85714V9.59524C32.5 10.6209 31.6685 11.4524 30.6428 11.4524H26.3095V17.3333H23.8333V11.4524H19.1905C18.1648 11.4524 17.3333 10.6209 17.3333 9.59524V1.85714Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.1667 6.50004H21.6667V4.33337H28.1667V6.50004Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.74998 14.926C11.4119 14.926 12.7592 13.5788 12.7592 11.9168C12.7592 10.2548 11.4119 8.90753 9.74998 8.90753C8.08801 8.90753 6.74072 10.2548 6.74072 11.9168C6.74072 13.5788 8.08801 14.926 9.74998 14.926ZM9.74998 17.3335C12.7415 17.3335 15.1666 14.9083 15.1666 11.9168C15.1666 8.92525 12.7415 6.50012 9.74998 6.50012C6.75844 6.50012 4.33331 8.92525 4.33331 11.9168C4.33331 14.9083 6.75844 17.3335 9.74998 17.3335Z"
      fill="currentColor"
    />
  </svg>
)

export { ChemicalTest20 }
